import type { Tier } from '@/lib/thresholds';

export type ColorTierName = 'good' | 'watch' | 'bad';
export type ColorTiers = Record<string, ColorTierName>;

const TIER_OF: Record<ColorTierName, Tier> = { good: 'ok', watch: 'warning', bad: 'critical' };

/**
 * The tier a water colour word has on this farm, or null when the farm has not said (no marker).
 * Which colours are good or bad is the farm's call; nothing here knows a colour.
 */
export const normalizeColorWord = (word: string): string => word.trim().toLowerCase().replace(/[\s-]+/g, '_');

export function waterColorTier(tiers: ColorTiers | undefined, color: string | null | undefined): Tier | null {
  const name = color ? tiers?.[normalizeColorWord(color)] : undefined;
  return name ? TIER_OF[name] : null;
}
